import ApiService from "@/core/services/ApiService";
import JwtService from "@/core/services/JwtService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface Survey {
  name: string;
  api_token: string;
}

export interface SurveyDetaiInfor {
  errors: unknown;
  Survey: Survey;
  isAuthenticated: boolean;
}

@Module
export default class SurveyDetail
  extends VuexModule
  implements SurveyDetaiInfor
{
  errors = {};
  Survey = {} as Survey;
  isAuthenticated = !!JwtService.getToken();

  /**
   * Get current user object
   * @returns User
   */
  get SurveyDetail() {
    return this.surveyDetailData;
  }

  /**
   * Verify user authentication
   * @returns boolean
   */

  @Mutation
  [Mutations.SET_ERROR](error) {
    this.errors = { ...error };
  }

  @Mutation
  [Mutations.SURVEYS_DETAIL_DATA](Survey) {
    this.surveyDetailData = Survey;
  }
  @Action
  [Actions.SURVEY_DETAIL](payload) {
    return ApiService.getDataDetail("/survey", payload, "detail", payload)
      .then(({ data }) => {
        this.context.commit(Mutations.SURVEYS_DETAIL_DATA, data);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.PURE_AUTH_AND_SET_ERROR, response.data);
      });
  }
}
